import { BotIcon } from "./BotIcon.js";
import { t } from "../lib/i18n.js";

interface FarewellViewProps {
  botAvatar: string | null;
  language: string;
  onDismiss: () => void;
}

/**
 * Brief thank-you shown when the visitor closes an active conversation.
 * Auto-dismissed by the caller after ~2s; any click closes immediately.
 */
export function FarewellView({ botAvatar, language, onDismiss }: FarewellViewProps) {
  return (
    <div
      class="flex flex-col h-full bg-[var(--background)] rounded-2xl shadow-lg overflow-hidden cursor-pointer"
      onClick={onDismiss}
    >
      <div class="flex-1 flex flex-col items-center justify-center px-6 animate-fadeIn">
        <div class="size-12 rounded-full bg-[var(--primary)] flex items-center justify-center mb-4 overflow-hidden">
          {botAvatar ? (
            <img src={botAvatar} alt="" class="size-12 rounded-full object-cover" />
          ) : (
            <BotIcon class="size-6 text-[var(--primary-foreground)]" />
          )}
        </div>
        <p class="text-sm font-medium text-[var(--foreground)] text-center">
          {t("farewell.thanks", language)}
        </p>
      </div>
    </div>
  );
}
